/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Csv_To_JsonInputs */

const en_sidebar_csv_to_json = /** @type {(inputs: Sidebar_Csv_To_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV → JSON`)
};

const ko_sidebar_csv_to_json = /** @type {(inputs: Sidebar_Csv_To_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV → JSON`)
};

const ja_sidebar_csv_to_json = /** @type {(inputs: Sidebar_Csv_To_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV → JSON`)
};

/**
* | output |
* | --- |
* | "CSV → JSON" |
*
* @param {Sidebar_Csv_To_JsonInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_csv_to_json = /** @type {((inputs?: Sidebar_Csv_To_JsonInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Csv_To_JsonInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_csv_to_json(inputs)
	if (locale === "ko") return ko_sidebar_csv_to_json(inputs)
	return ja_sidebar_csv_to_json(inputs)
});